module.exports = __webpack_public_path__ + "static/media/Screenshot_6.34d5fa03.png";